/**
 * Network connection monitor for detecting online/offline state
 * and triggering callbacks when connection is restored.
 */
export class NetworkMonitor {
  constructor() {
    this.isOnline = navigator.onLine;
    this.reconnectCallbacks = [];

    this.init();
  }

  init() {
    window.addEventListener('online', () => {
      const wasOffline = !this.isOnline;

      this.isOnline = true;
      
      if (wasOffline) {
        this.reconnectCallbacks.forEach(cb => cb());
      }
    });

    window.addEventListener('offline', () => {
      this.isOnline = false;
    });
  }

  onReconnect(callback) {
    this.reconnectCallbacks.push(callback);
  }

  removeReconnectListener(callback) {
    this.reconnectCallbacks = this.reconnectCallbacks.filter(cb => cb !== callback);
  }

  isConnected() {
    return this.isOnline;
  }
}

export const globalNetworkMonitor = new NetworkMonitor();
